// extracted by mini-css-extract-plugin
module.exports = {"drag_and_drop_keypad":"DragAndDropKeypad_drag_and_drop_keypad__KWZDS","call":"DragAndDropKeypad_call__ZZD52"};